import avanceJaWhite from './avance_ja_white.svg';
import avanceJaDefault from './avance_ja.svg';
import checkUpWhite from './check_up_white.svg';
import checkUp from './checkup.svg';
import confirmeJaWhite from './confirme_ja_white.svg';
import confirmeJa from './confirme_ja.svg';
import headerLogo from './header-logo.svg';
import footerLogo from './logo-footer.svg';
import logo from './logo.png';
import defaultProfilePic from './DefaultProfilePic.png';
import notificacoes from './notificacoes.png';
import recebaJaWhite from './receba_ja_white.svg';
import recebaJa from './receba_ja.svg';
import resolvaJaWhite from './resolva_ja_white.svg';
import resolvaJaSvg from './resolva_ja.svg';
import resolvaJaPng from './resolva_ja.png';
import show from './show.svg';
import snsJaWhite from './sns_ja_white.svg';
import snsJa from './sns_ja.svg';

export const avanceJaWhiteImage = avanceJaWhite;
export const avanceJaDefaultImage = avanceJaDefault;
export const checkUpWhiteImage = checkUpWhite;
export const checkUpImage = checkUp;
export const confirmeJaWhiteImage = confirmeJaWhite;
export const confirmeJaImage = confirmeJa;
export const headerLogoImage = headerLogo;
export const footerLogoImage = footerLogo;
export const logoImage = logo;
export const notificacoesImage = notificacoes;
export const recebaJaWhiteImage = recebaJaWhite;
export const recebaJaImage = recebaJa;
export const resolvaJaWhiteImage = resolvaJaWhite;
export const resolvaJaSvgImage = resolvaJaSvg;
export const resolvaJaPngImage = resolvaJaPng;
export const showImage = show;
export const snsJaWhiteImage = snsJaWhite;
export const snsJaImage = snsJa;
export const defaultProfile = defaultProfilePic;
